import AnnouncementCarousel from '../../components/AnnouncementCarousel';
import formatFreeShippingThresholds from '../../utils/formatFreeShippingThreshold';

const announcements = {};

const announcementInit = (carousel, index) => {
  formatFreeShippingThresholds(carousel);

  const elements = carousel.querySelectorAll('#country-picker');
  elements.forEach((element) => {
    element.remove();
  });

  const track = carousel.querySelector('[data-announcements-track]');
  if (!track || track.children.length < 2) {
    // Don't init pointless carousels with 1 or no slides
    return;
  }

  const id = carousel.parentElement.getAttribute('id');
  announcements[id] = new AnnouncementCarousel(carousel, {
    initialIndex: index || 0,
    prevNextButtons: carousel.dataset.prevNextButtons === 'true',
    autoPlay: carousel.dataset.autoPlay,
  });
};

export { announcements, announcementInit };
